/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbTypeEvaluationDto } from './FcbTypeEvaluationDto';
import {
    FcbTypeEvaluationDtoFromJSON,
    FcbTypeEvaluationDtoFromJSONTyped,
    FcbTypeEvaluationDtoToJSON,
} from './FcbTypeEvaluationDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbTypeEvaluationDtoPaginatedResults
 */
export interface FcbTypeEvaluationDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbTypeEvaluationDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbTypeEvaluationDto>}
     * @memberof FcbTypeEvaluationDtoPaginatedResults
     */
    results?: Array<FcbTypeEvaluationDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbTypeEvaluationDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbTypeEvaluationDtoPaginatedResults interface.
 */
export function instanceOfFcbTypeEvaluationDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbTypeEvaluationDtoPaginatedResultsFromJSON(json: any): FcbTypeEvaluationDtoPaginatedResults {
    return FcbTypeEvaluationDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbTypeEvaluationDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbTypeEvaluationDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbTypeEvaluationDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbTypeEvaluationDtoPaginatedResultsToJSON(value?: FcbTypeEvaluationDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbTypeEvaluationDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

